import type { IdOrIdentifier } from "~/tools/id-or-identifier";

import { useErrorMessage } from "../../../../components/_notification-error";
import { useNavigateTo } from "../../../../components/react/link";
import { modalConfirmCancellable } from "../../../../components/react/modal/modal-utils";
import { notification } from "../../../../components/react/notification/Notification";
import { useOptimisticDeleteDashboard } from "../../../../queries/dashboards";
import { DASHBOARDS_OVERVIEW_PATH } from "../../../Routes";

export function useDeleteDashboard({ onConfirm }: { onConfirm: VoidFunction }) {
	const navigateTo = useNavigateTo();
	const { displayErrorMessage } = useErrorMessage();

	const { mutate: remove } = useOptimisticDeleteDashboard({
		onError: (error) => {
			displayErrorMessage({
				message: "Something went wrong while trying to delete a dashboard",
				error,
			});
		},

		onSuccess: () => {
			notification.success({
				message: "Dashboard has been successfully deleted.",
			});
		},
	});

	return (idOrIdentifier: IdOrIdentifier, dashboardName: string): void => {
		void modalConfirmCancellable(
			`Are you sure you want to permanently delete "${dashboardName}"? This action cannot be undone.`,
			{
				onOk: () => {
					onConfirm();
					navigateTo(DASHBOARDS_OVERVIEW_PATH, {
						search: ["timeRange", "timestamp", "detachedFilters"],
					});
					remove(idOrIdentifier);
				},
			},
		);
	};
}
